import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IGenericDialogDataRequired } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-generic-required-data',
  templateUrl: './generic-required-data.component.html',
  styleUrl: './generic-required-data.component.scss',
})
export class GenericRequiredDataComponent implements OnInit {
  title: string = '';
  primaryVerbiage: string = '';

  readonly dialogRef = inject(MatDialogRef<GenericRequiredDataComponent>);
  readonly data = inject<IGenericDialogDataRequired>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.title = this.data.title;
    this.primaryVerbiage = this.data.primaryVerbiage;
  }
}
